module.exports = __webpack_public_path__ + "static/media/altologo2.332cf103.svg";